import { useEnrollRewardsUserWebApiHandler_enrollUser } from '@zg-rentals/ts-rent-payment-client-react-query';

/**
 * Hook to enroll user into the rewards program.
 *
 * - `enroll`              – async function to trigger enrollment
 * - `isEnrolling`         – whether enrollment is in progress
 * - `hasEnrollmentError`  – whether the last enrollment attempt failed
 */
export function useRewardsEnroll() {
  const {
    mutateAsync: enroll,
    isPending: isEnrolling,
    isError: hasEnrollmentError,
  } = useEnrollRewardsUserWebApiHandler_enrollUser();

  return {
    enroll,
    isEnrolling,
    hasEnrollmentError,
  };
}
